import { SimpleCardComponent } from '@aipb/shared/ui/card';

import { Component, inject } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { MatDividerModule } from '@angular/material/divider';
import { TranslocoModule } from '@jsverse/transloco';
import { NewsListComponent } from '../../components';
import { NEWS } from '../../news.tokens';

@Component({
  selector: 'cat-news-page',
  templateUrl: './news-page.component.html',
  styleUrls: ['./news-page.component.scss'],
  standalone: true,
  imports: [SimpleCardComponent, TranslocoModule, NewsListComponent, MatCardModule, MatDividerModule]
})
export class NewsPageComponent {
  items = inject(NEWS);
}
